<template>
    <div>
        <div class="header">
            <div class="search">
                <input
                    type="text"
                    placeholder="搜索网吧名/计算机名"
                    v-model="txt"
                    @keyup.enter="getServerTableList(page)"
                    @blur="getServerTableList(page)"
                />
                <a href="#" @click.prevent="getServerTableList(page)"
                    ><img src="@/assets/img/icon/u502.png" alt=""
                /></a>
            </div>
            <span>服务器标签：</span>
            <select v-model="labelId" @change="getServerTableList(page)">
                <option value="">全部</option>
                <option
                    v-for="(item, index) in serverLabelList"
                    :key="index"
                    :value="item.labelName"
                    v-text="item.labelName"
                ></option>
            </select>
            <span>类型：</span>
            <select v-model="type" @change="getServerTableList(page)">
                <option value="">全部</option>
                <option
                    v-for="(item, index) in typeList"
                    :key="index"
                    :value="item.value"
                    v-text="item.label"
                ></option>
            </select>
            <span>分组名：</span>
            <select v-model="groupId" @change="getServerTableList(page)">
                <option value="">全部</option>
                <option
                    v-for="(item, index) in groupList"
                    :key="index"
                    :value="item.groupId"
                    v-text="item.groupName"
                ></option>
            </select>
            <span>在线状态：</span>
            <select v-model="onlineStatus" @change="getServerTableList(page)">
                <option value="">全部</option>
                <option
                    v-for="(item, index) in onlineStatusList"
                    :key="index"
                    :value="item.value"
                    v-text="item.label"
                ></option>
            </select>
            <span>下载状态：</span>
            <select v-model="downloadId" @change="getServerTableList(page)">
                <option value="">全部</option>
                <option
                    v-for="(item, index) in downloadList"
                    :key="index"
                    :value="item.value"
                    v-text="item.label"
                ></option>
            </select>
        </div>
        <div class="table-content">
            <server-table-list
                ref="serverTableList"
                @pagechange="getServerTableList"
                :total="parseInt(total)"
                :page="parseInt(page)"
                :loading="loading"
                :table-list="serverList"
            ></server-table-list>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { getServerTableList } from "@/requests/threeTierMission";
import ServerTableList from "./serverTableList";
export default {
    name: "server",
    components: {
        ServerTableList,
    },
    data() {
        return {
            txt: "",
            labelId: "",
            downloadId: "",
            downloadList: [
                {
                    value: 1,
                    label: "下载中",
                },
                {
                    value: 2,
                    label: "下载完成",
                },
                {
                    value: 3,
                    label: "下载失败",
                },
                {
                    value: 0,
                    label: "未下载",
                },
            ],
            groupId: "",
            type: "",
            typeList: [
                {
                    value: 1,
                    label: "主",
                },
                {
                    value: 0,
                    label: "副",
                },
            ],
            onlineStatus: "",
            onlineStatusList: [
                {
                    value: 1,
                    label: "在线",
                },
                {
                    value: 0,
                    label: "离线",
                },
            ],
            total: 0,
            page: 1,
            serverList: [],
            loading: false,
            task: 0,
        };
    },
    computed: {
        ...mapState({
            groupList: (state) => state.user.barGroupList,
            serverLabelList: (state) => state.serverLabel.serverLabelList,
        }),
        allCheck() {
            return this.$refs.serverTableList.allCheck;
        },
        barIdList() {
            return this.$refs.serverTableList.selectedBarIds();
        },
    },
    methods: {
        // 分页获取服务器列表
        async getServerTableList(pageNum) {
            this.serverList = [];
            this.loading = true;
            let res = await getServerTableList({
                current: pageNum,
                size: 20,
                search: this.txt,
                taskId: this.task,
                labelName: this.labelId,
                type: this.type,
                groupId: this.groupId,
                onlineStatus: this.onlineStatus,
                downloadStatus: this.downloadId,
            });
            this.serverList = res.data.records;
            this.total = parseInt(res.data.total);
            this.page = parseInt(res.data.current);
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
    background: #fff;
    padding: 5px;
    border: 1px solid rgba(230, 230, 230, 1);
    .search {
        display: inline-block;
        input {
            width: 180px;
            height: 30px;
            border: 1px solid rgba(230, 230, 230, 1);
            font-size: 12px;
            color: #a1a1a1;
            padding-left: 10px;
        }
        a {
            display: inline-block;
            width: 61px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background: rgba(242, 242, 242, 1);
            border: 1px solid rgba(230, 230, 230, 1);
            border-left: none;
            margin-right: 10px;
        }
    }
}
select {
    outline: none;
    width: 120px;
    height: 30px;
    line-height: 30px;
    border: 1px solid rgba(230, 230, 230, 1);
    margin: 0px 10px 10px 0;
}
</style>
